var _defs, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 600,
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circular-border"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 280
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "avoid-antialiasing-bugs"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 498
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 280,
    fill: "#6F6DEB",
    clipPath: "url(#avoid-antialiasing-bugs)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 230,
    r: 115
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 550,
    r: 205,
    clipPath: "url(#circular-border)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.32bf3cb2499e23cb318852ecb97c2d6e.svg";
export { ForwardRef as ReactComponent };